import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4855c7d6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "filter-parameter__item" }

import { computed, DefineComponent, onMounted, PropType, watch } from 'vue';
import { FilterOptionModalItem, OptionItemModel } from '../../../models';
import { OptionFilterEnum } from '../../../enums';
import FilterGlobalStatusesParameter from './FilterGlobalStatusesParameter.vue';
import { TirCheckbox, TirPmRadio } from 'tir-components';
import FilterProjectsParameter from './FilterProjectsParameter.vue';
import { TaskParameterTypeEnum } from '@/components/task-parameter';
import { ref } from 'vue';

/**Параметры */

export default /*#__PURE__*/_defineComponent({
  __name: 'FilterParameterItem',
  props: {
  /**Тип параметра */
  typeParameter: {
    type: Object as PropType<TaskParameterTypeEnum>,
  },
  /**Отображаемый компонент */
  showComponent: {
    type: Object as () => DefineComponent<{}, {}, any>,
    required: true,
  },
  /**Данная опции фильтра */
  item: {
    type: Object as PropType<OptionItemModel>,
    required: true,
  },
  /**Опция */
  option: {
    type: Object as PropType<OptionFilterEnum>,
    required: true,
  },
  /**Скрытые элементы */
  hiddenElements: {
    type: Object as PropType<OptionItemModel[]>,
  },
  /**Данные опции фильтра */
  filterOptionData: {
    type: Object as PropType<FilterOptionModalItem>,
    required: true,
  },
},
  emits: ["toggleItem"],
  setup(__props, { emit }) {

const props = __props;


/**События */


/**Состояние радиокнопки */
const isSelectRadio = computed({
  get: () => {
    return props.filterOptionData.SelectedOptions.some((elem) => elem.Id == props.item.Id) ? 1 : 0;
  },
  set: () => {
    emit('toggleItem', props.item, props.option, false);
  },
});
/**Состояние чек бокса */
const isSelectCheckBox = computed<boolean>({
  get: () => {
    return (
      props.filterOptionData.SelectedOptions.some((elem) => elem.Id === props.item.Id) ||
      props.filterOptionData.HiddenElements[props.option]?.some((elem) => elem.Id === props.item.Id)
    );
  },
  set: () => {
    emit('toggleItem', props.item, props.option, true);
  },
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!__props.filterOptionData.isMultiSelect)
      ? (_openBlock(), _createBlock(_unref(TirPmRadio), {
          key: 0,
          modelValue: isSelectRadio.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isSelectRadio).value = $event)),
          value: 1
        }, null, 8, ["modelValue"]))
      : (_openBlock(), _createBlock(_unref(TirCheckbox), {
          key: 1,
          modelValue: isSelectCheckBox.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((isSelectCheckBox).value = $event))
        }, null, 8, ["modelValue"])),
    (_openBlock(), _createBlock(_resolveDynamicComponent(__props.showComponent), {
      type: __props.typeParameter,
      item: __props.item,
      selectedOptionsFilter: __props.filterOptionData.SelectedOptions
    }, null, 8, ["type", "item", "selectedOptionsFilter"]))
  ]))
}
}

})